import { Grid } from '@mui/material'
import { Button, Section, Typography } from '@wolfdanepug/common-react'

export default function NotFound() {
	return (
		<Section sx={styles.root}>
			<Grid container>
				<Grid item xs={12} md={5}>
					<Typography variant="h1" color={'primary'} pb={3} sx={styles.code}>
						404
					</Typography>
					<Typography variant="h2" sx={styles.title}>
						Oops!
						<br /> Where are we?
					</Typography>
					<Typography pb={2}>
						Page not Found! The page you are looking for was moved, removed, renamed or might never
						existed.
					</Typography>
					<Button LinkComponent={'a'} variant="contained" size="large" href="/">
						Back to homepage
					</Button>
				</Grid>
			</Grid>
		</Section>
	)
}

const styles = {
	root: {
		root: {
			pt: 15,
			pb: 15
		}
	},
	code: {
		fontFamily: 'Monoton, serif',
		fontSize: 100
	},
	title: {
		fontSize: 72,
		whiteSpace: 'nowrap'
	}
}
